import { Grid, Card, Paper, Button } from "@mui/material"
import { useQuery } from "@apollo/client"
import { useEffect } from "react"
import { useNavigate, useParams } from "react-router"
import { GET_LOCATION } from "../../features/graphql/query"
import { LoadingWrapper, Header } from "ui"
import { People } from "@mui/icons-material"
import LocationForm from "./components/LocationForm"
import { CustomFieldTable } from "./components/CustomFieldTable"
const CompanyLocationPage = ({ onBack }: { onBack: () => void }) => {
    const { lid } = useParams();
    const navigate = useNavigate();
    const handleGoToManageStaff = () => {
        navigate("staff")
    }
    const { loading, data } = useQuery(GET_LOCATION, {
        variables: { id: lid }
    })
    useEffect(() => {

    }, [loading, data])
    const subTitle = `Total Staff Users: ${data?.location?.totalStaff ?? 'N/A'}; \n\n Total Students: ${data?.location?.totalStudents ?? 'N/A'}`
    return (
        <LoadingWrapper loading={loading}>
            <Card elevation={4} style={{ width: "100%", display: "flex", padding: "16px", height: "auto" }}>
                <Grid container spacing={2}>
                    <Grid size={6}>
                        <Header title={data?.location?.name ?? ''} onBack={onBack} subtitle={subTitle} />
                    </Grid>
                    <Grid size={6} sx={{ textAlign: "end", alignContent: "center" }}>
                        <Button
                            onClick={handleGoToManageStaff}
                            startIcon={<People />}>Manage Staff</Button>
                    </Grid>
                    <Grid size={6} sx={{ padding: 0 }}>
                        <LocationForm
                            readonly={true}
                            initialValues={{
                                name: data?.location?.name ?? '',
                                streetLineOne: data?.location?.streetLineOne ?? '',
                                streetLineTwo: data?.location?.streetLineTwo ?? '',
                                city: data?.location?.city ?? '',
                                state: data?.location?.state ?? '',
                                postalCode: data?.location?.postalCode ?? '',
                                country: data?.location?.country ?? ''
                            }}
                        />
                    </Grid>
                    <Grid size={6}>
                        <Paper component="div" variant="outlined">
                            <CustomFieldTable customfields={data?.location?.customFields} />
                        </Paper>
                    </Grid>
                </Grid>
            </Card>
        </LoadingWrapper>
    )
}

export default CompanyLocationPage